import React, { Suspense, useState, useRef, useEffect } from "react";
import "../Registration/Registration.css";
import "bootstrap/dist/css/bootstrap.min.css";
import OtpInput from "react-otp-input";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useHistory,
  useLocation,
} from "react-router-dom";
import { Button, Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { BsFacebook } from "react-icons/bs";
import Loading from "../../components/Loading";
import Header from "../../DefaultLayout/Header";
import Footer from "../../DefaultLayout/Footer";
import NavbarSection from "../../DefaultLayout/Navbar";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import { BiFirstAid } from "react-icons/bi";
import { checkRequiredValidationWithOTPMinMax } from "../../Helpers/Validation";
import { useDispatch, useSelector, connect } from "react-redux";
import ToastifyContainer from "../../components/Toastify/ToastifyContainer";
import { toast } from "react-toastify";
import firebase from "../../Helpers/firebase";
import { verifyEmailOtp } from "../../actions/forgotPasswordAction";
import { sendEmail } from "./../../actions/forgotPasswordAction";

const VerifyOTP = (props) => {
  const { frontLabelsName } = props.label;
  const [otp, setOtp] = useState(0);
  const dispatch = useDispatch();
  const reCaptchRef = useRef();
  const history = useHistory();

  const location = useLocation();
  // const { detail } = location.state;
  // let gettingEmail = detail
  const [error_OTP, setErrorOTP] = useState("");
  const [seconds, setSeconds] = useState(30);
  const [resendCode, setResendCode] = useState(false);
  //   const [loading, setLoading] = useState(false);

  const CheckOtp = useSelector((state) => state.forgotOtp);
  const { forgotData, checkVerify, loading } = CheckOtp;

  useEffect(() => {
    if (location?.state?.detail === undefined) {
      history.push("/login")
    }
  }, []);

  const handleChange = (data) => {
    setOtp(data);
  };

  const handleVerify = (e) => {
    e.preventDefault();
    let errOtp = null;
    let validationFlag = true;
    errOtp = checkRequiredValidationWithOTPMinMax(otp, "lbl_OTP", 6);
    if (errOtp) {
      validationFlag = false;
      setErrorOTP(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == errOtp)
          .length > 0
          ? frontLabelsName.filter((e) => e.key == errOtp)[0][
          "value"
          ] || errOtp
          : errOtp
        : errOtp);
    } else {
      validationFlag = true;
      setErrorOTP("");
    }
    if (validationFlag) {
      //   setLoading(true);

      const userObj = {
        email: location?.state?.detail,
        otp: otp,
      };
      props.verifyEmailOtp(userObj).then((res) => {
        // if (res.status === 200) {
        toast.success(frontLabelsName
          ? frontLabelsName.filter((e) => e.key == res.data.message)
            .length > 0
            ? frontLabelsName.filter((e) => e.key == res.data.message)[0][
            "value"
            ] || res.data.message
            : res.data.message
          : res.data.message)
        setTimeout(() => {
          history.push({
            pathname: "/reset-password",
            state: {
              detail: location?.state?.detail,
              checkVerify: true
            }
          });

        }, 2000);
        // }
      }).catch((err) => {
        toast.error(frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err.response.data.message)
            .length > 0
            ? frontLabelsName.filter((e) => e.key == err.response.data.message)[0][
            "value"
            ] || err.response.data.message
            : err.response.data.message
          : err.response.data.message);
      });
    }
  };

  const onResendOtp = async (e) => {
    e.preventDefault();
    let newObj = {
      email: location?.state?.detail,
      resend: "2",
    };
    props.sendEmail(newObj).then((res) => {
      toast.success(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == res.data.message)
          .length > 0
          ? frontLabelsName.filter((e) => e.key == res.data.message)[0][
          "value"
          ] || res.data.message
          : res.data.message
        : res.data.message)
    }).catch((err) => {
      toast.error(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == err.response.data.message)
          .length > 0
          ? frontLabelsName.filter((e) => e.key == err.response.data.message)[0][
          "value"
          ] || err.response.data.message
          : err.response.data.message
        : err.response.data.message);
    });
  };

  if (location?.state?.detail === undefined) {
    history.push("/login");
  }

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <Header />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="container mb-5 pt-5">
        <div className="row">
          <ToastifyContainer />

          <div className="main-otp-box">
            <div className="otp-box-rg-new pb-5">
              <form>
                <div className="img-mob text-center">
                  <img src="assets/ver2.svg" alt="mobile" />
                  <h2>
                    <strong>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_otp_verification"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_otp_verification"
                          )[0]["value"] || "lbl_otp_verification"
                          : "lbl_otp_verification"
                        : "lbl_otp_verification"}
                    </strong>
                  </h2>
                  <p className="color-set-otp">
                    {frontLabelsName
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_enter_otp"
                      ).length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_enter_otp"
                        )[0]["value"] || "lbl_enter_otp"
                        : "lbl_enter_otp"
                      : "lbl_enter_otp"}
                    <strong> {location?.state?.detail}</strong>
                  </p>

                  <div className="four-text-box d-flex">
                    <OtpInput
                      value={otp}
                      onChange={handleChange}
                      OTPLength={6}
                      numInputs={6}
                      type="number"
                      inputStyle={{ width: "2em", margin: "5px" }}
                      autofocus
                      disabled={false}
                      secure
                      isInputNum
                    />
                  </div>
                  {error_OTP && (
                    <span style={{ color: "red" }}>{error_OTP}</span>
                  )}
                  <p className="color-set-otp">
                    <p>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_dont_receive_otp"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_dont_receive_otp"
                          )[0]["value"] || "lbl_dont_receive_otp"
                          : "lbl_dont_receive_otp"
                        : "lbl_dont_receive_otp"}
                      <strong
                        className="text-dark"
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={(e) => onResendOtp(e)}
                      >
                        {" "}
                        {frontLabelsName
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_resend_otp"
                          ).length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_resend_otp"
                            )[0]["value"] || "lbl_resend_otp"
                            : "lbl_resend_otp"
                          : "lbl_resend_otp"}
                      </strong>
                    </p>
                  </p>
                  <div ref={reCaptchRef}>
                    <div id="resend-button" hidden={!resendCode}></div>
                  </div>
                  <div className="button-set pt-3">
                    {/* <Link to="/dashboard"> */}
                    <Button
                      onClick={handleVerify}
                      disabled={loading}
                      type="submit"
                    >
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_verify"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_verify"
                          )[0]["value"] || "lbl_verify"
                          : "lbl_verify"
                        : "lbl_verify"}
                    </Button>
                    {/* </Link> */}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  label: state.language
})
export default connect(mapStateToProps, {
  verifyEmailOtp,
  sendEmail,
})(VerifyOTP);
